/* CLOVEBY — mini cart drawer (branded add-to-cart confirmation) */
(function () {
  'use strict';
  var C = window.CLOVEBY || {};
  var R = C.routes || {};
  var root = (R.root || '/').replace(/\/$/, '');
  var cartUrl = R.cart || '/cart';
  var S = { added: 'Added to your cart', title: 'Your Cart', empty: 'Your cart is empty.', subtotal: 'Subtotal', note: 'Shipping & taxes calculated at checkout.', checkout: 'Checkout', viewCart: 'View Cart', cont: 'Continue Shopping', remove: 'Remove', error: (C.strings && C.strings.error) || 'Something went wrong. Please try again.', adding: (C.strings && C.strings.adding) || 'Adding…', free: 'Free shipping on orders over $50' };

  function money(cents) {
    var fmt = C.moneyFormat || '${{amount}}';
    cents = parseInt(cents, 10) || 0;
    function f(n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return f(cents, 2, "'", '.');
      return f(cents, 2, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function icon(n) {
    var p = { close: '<path d="M6 6l12 12M18 6 6 18"/>', check: '<path d="m5 12.5 4.2 4.2L19 7"/>', minus: '<path d="M5 12h14"/>', plus: '<path d="M12 5v14M5 12h14"/>', lock: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>', bag: '<path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>' }[n];
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }

  var drawer, panel, body, foot, head, lastFocus, busy = false;
  function build() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'cb-cd';
    drawer.id = 'CbCartDrawer';
    drawer.hidden = true;
    drawer.innerHTML = '<div class="cb-cd__overlay" data-cd-close></div>' +
      '<aside class="cb-cd__panel" role="dialog" aria-modal="true" aria-labelledby="CbCdTitle" tabindex="-1">' +
      '<header class="cb-cd__head"><div><p class="cb-cd__status" data-cd-status hidden>' + icon('check') + '<span>' + S.added + '</span></p><h2 class="cb-cd__title" id="CbCdTitle">' + S.title + ' <span data-cd-count></span></h2></div>' +
      '<button type="button" class="cb-cd__x" data-cd-close aria-label="Close">' + icon('close') + '</button></header>' +
      '<div class="cb-cd__body" data-cd-body></div><footer class="cb-cd__foot" data-cd-foot></footer></aside>';
    document.body.appendChild(drawer);
    panel = drawer.querySelector('.cb-cd__panel');
    body = drawer.querySelector('[data-cd-body]');
    foot = drawer.querySelector('[data-cd-foot]');
    head = drawer.querySelector('[data-cd-status]');
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
      var q = e.target.closest('[data-cd-qty]');
      if (q) { change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-cd-qty'), 10)); return; }
      var rm = e.target.closest('[data-cd-remove]');
      if (rm) { change(rm.getAttribute('data-key'), 0); }
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input')).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  function render(cart) {
    var countEl = drawer.querySelector('[data-cd-count]');
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    if (!cart.item_count) {
      body.innerHTML = '<div class="cb-cd__empty">' + icon('bag') + '<p>' + S.empty + '</p><a href="' + (R.root || '/') + 'collections/all" class="cb-btn">' + S.cont + '</a></div>';
      foot.innerHTML = '';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = '<ul class="cb-cd__items">' + cart.items.map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="cb-cd__item">' +
        '<a class="cb-cd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="120" height="120" loading="lazy">' : '') + '</a>' +
        '<div class="cb-cd__info"><a class="cb-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (opts ? '<p class="cb-cd__opt">' + opts + '</p>' : '') +
        '<p class="cb-cd__unit">' + money(it.final_price) + '</p>' +
        '<div class="cb-cd__row"><div class="cb-cd__qty" role="group" aria-label="Quantity">' +
        '<button type="button" data-cd-qty="' + (it.quantity - 1) + '" data-key="' + esc(it.key) + '" aria-label="Decrease quantity">' + icon('minus') + '</button>' +
        '<span aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" data-cd-qty="' + (it.quantity + 1) + '" data-key="' + esc(it.key) + '" aria-label="Increase quantity">' + icon('plus') + '</button></div>' +
        '<button type="button" class="cb-cd__rm" data-cd-remove data-key="' + esc(it.key) + '">' + S.remove + '</button></div></div>' +
        '<div class="cb-cd__price">' + was + '<span>' + money(it.final_line_price) + '</span></div></li>';
    }).join('') + '</ul>';
    var disc = cart.total_discount > 0 ? '<div class="cb-cd__line"><span>Savings</span><span>−' + money(cart.total_discount) + '</span></div>' : '';
    foot.innerHTML = disc + '<div class="cb-cd__line cb-cd__line--total"><span>' + S.subtotal + '</span><span>' + money(cart.total_price) + '</span></div>' +
      '<p class="cb-cd__note">' + S.note + '</p>' +
      '<a href="' + root + '/checkout" class="cb-btn cb-cd__checkout">' + icon('lock') + ' ' + S.checkout + '</a>' +
      '<div class="cb-cd__links"><a href="' + cartUrl + '">' + S.viewCart + '</a><button type="button" data-cd-close>' + S.cont + '</button></div>';
  }

  function fetchCart() { return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function open(added) {
    build();
    lastFocus = document.activeElement;
    head.hidden = !added;
    drawer.hidden = false;
    document.documentElement.classList.add('cb-cd-open');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); panel.focus({ preventScroll: true }); });
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cb-cd-open');
    setTimeout(function () { drawer.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function change(key, qty) {
    if (busy) return; busy = true;
    drawer.classList.add('is-busy');
    fetch((R.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items) render(cart); else return fetchCart().then(render); })
      .catch(function () {})
      .finally(function () { busy = false; drawer.classList.remove('is-busy'); });
  }
  function add(form, btn, errEl) {
    var label = btn ? (btn.querySelector('[data-atc-label]') || btn) : null;
    var original = label ? label.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; if (label === btn) { label.textContent = S.adding; } else if (label) { label.textContent = S.adding; } }
    if (errEl) errEl.hidden = true;
    fetch((R.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || S.error);
        return fetchCart();
      })
      .then(function (cart) { build(); render(cart); open(true); })
      .catch(function (err) {
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
        else { build(); body.innerHTML = '<p class="cb-cd__error" role="alert">' + esc(err.message) + '</p>'; foot.hidden = true; open(false); }
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; if (label) label.innerHTML = original; } });
  }

  // Capture phase: runs before the base theme handler so only the drawer flow fires.
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.matches('[data-cb-add]')) {
      e.preventDefault(); e.stopPropagation();
      add(form, form.querySelector('button[type=submit]'));
    } else if (form.matches('[data-cb-product-form]')) {
      e.preventDefault(); e.stopPropagation();
      add(form, form.querySelector('[data-atc]'), form.querySelector('[data-form-error]'));
    }
  }, true);

  // Header bag icon opens the drawer (except on the cart page itself).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cart-link]');
    if (!a || e.metaKey || e.ctrlKey || /\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault();
    build();
    fetchCart().then(function (cart) { render(cart); open(false); }).catch(function () { location.href = a.href; });
  });

  window.CLOVEBY = window.CLOVEBY || {};
  window.CLOVEBY.cartDrawer = { open: function () { build(); fetchCart().then(function (c) { render(c); open(false); }); }, close: close };
})();
